import { addListener, removeListener } from '../../events/notifier';
import { eventsList } from '../../events/list';
import { benchmarkResponse, benchmarkUpload } from './benchmarks';
import { sendBiError } from './errors';
import { Uploader } from '../upload/upload-collection';
import { sendUploadQueueFinish, sendUploadQueueStart } from './upload-queue';
import { UploadQueueEvent } from '../../constants/upload-queue-event';
import { getCurrentTime } from '../../utils/utils';
function processEvents(events, isEnabled, biListener) {
  Object.keys(events).forEach(function (key) {
    const eventName = events[key];
    if (typeof eventName !== 'string') {
      return processEvents(eventName, isEnabled, biListener);
    }
    if (isEnabled === true) {
      addListener(events[key], biListener);
    } else {
      removeListener(events[key], biListener);
    }
  });
}
export function bi(isEnabled, options) {
  const biListener = function (promise, params) {
    // params.eventTarget
    // params.eventName

    // if called by emitWithArrayOfPromises
    if (Array.isArray(promise)) {
      promise = Promise.all(promise);
    }
    benchmarkResponse(promise, params);
    const reportSuccess = function () {};
    const requestStartTime = getCurrentTime();
    const reportError = function (response) {
      const currentOptions = {
        requestTimeMs: getCurrentTime() - requestStartTime,
        ...options
      };
      sendBiError(params.eventTarget.name, params.eventName, response, currentOptions);
    };
    return promise.then(reportSuccess, reportError);
  };
  processEvents(eventsList, isEnabled, biListener);
  if (isEnabled === true) {
    addListener(eventsList.ITEM.UPLOAD, benchmarkUpload);
  } else {
    removeListener(eventsList.ITEM.UPLOAD, benchmarkUpload);
  }
  if (isEnabled === true) {
    Uploader.on(UploadQueueEvent.UploadQueueStarted, sendUploadQueueStart);
    Uploader.on(UploadQueueEvent.UploadQueueFinished, sendUploadQueueFinish);
  }
}